import React, { Component } from 'react'
import { Route, Switch, Redirect } from "react-router-dom"
import Dashboard from "./dashboard"
import Report from "./report"
import DataManage from "./data_manage"
import RecycleBin from "./recycleBin"
import Statistics from './statistics'
import DataMangeDetail from "./data_manage_detail"
import RecycleDetail from "./recycle_detail"

export default class index extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/overview`} component={Dashboard} />
        <Route path={`${match.url}/report`} component={Report} />
        <Route exact path={`${match.url}/data_manage`} component={DataManage} />
        <Route path={`${match.url}/statistics`} component={Statistics} />
        <Route exact path={`${match.url}/recycle_bin`} component={RecycleBin} />
        <Route path={`${match.url}/data_manage/:id`} component={DataMangeDetail} />
        <Route path={`${match.url}/recycle_bin/:id`} component={RecycleDetail} />
        <Redirect from='*' to={`${match.url}/overview`} />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/index.js